import cx from "classnames";
import { CoreLink } from "common/CoreLink";
import { Icon } from "common/Icon";
import { PopoverLinkMenu, PopoverLinkMenuItem as LinkMenuItem } from "common/styleguide/PopoverLinkMenu";
import w from "lib/styleguide/widgets.scss";
import _ from "lodash";
import React, { useRef, useState } from "react";

const availableVariations = ["link", "small", "primary", "danger", "secondary", "facebook", "grey"];

const getCTATypeClass = (props) => {
  // find the first variation that occurs in props
  const variations = availableVariations.filter((v) => props[v]);
  return variations.length > 0 ? variations.map((v) => w[v + "CTA"]).join(" ") : w.primaryCTA;
};
// there's a reason you can't inject a className here. just use a wrapper.
// this is not a stateless component in order to enable refs
export const CTA = React.forwardRef((props, ref) => {
  const { inline, style, disabled, button, autoWidth, className, ...rest } = props;
  let { margins } = props;
  if (margins === undefined) {
    margins = true;
  }

  const type = getCTATypeClass(rest);
  const cn = cx(w.CTA, inline && w.inlineCTA, type, className, disabled && w.disabled);

  // support margins={false} AND autoWidth AND style overrides
  const _style = Object.assign(!margins && { margin: "0 0" }, autoWidth && { width: "auto" }, { ...style });

  const safeProps = _.omit(rest, availableVariations);
  const allProps = { className: cn, style: _style, ...safeProps };
  return button ? <button ref={ref} {...allProps} /> : <CoreLink ref={ref} {...allProps} />;
});

export const ThreeDotCTA = ({ menuItems, containerClassName, ...props }) => {
  const ref = useRef(null);
  const [show, setShow] = useState(false);

  const { children, onClick, onMouseEnter, onMouseLeave } = props;
  const ctaProps = {
    className: w.threeDotButton,
    children,
    onClick,
    onMouseEnter,
    onMouseLeave,
  };

  const onItemClick = (action) => {
    setShow(false);
    action();
  };
  const actions = menuItems.keySeq().map((k) => (
    <LinkMenuItem key={k} onClick={() => onItemClick(menuItems.get(k))}>
      {k}
    </LinkMenuItem>
  ));

  return (
    <div className={cx(w.threeDotContainer, containerClassName)}>
      <a {...ctaProps} />
      <a onClick={() => setShow(!show)} className={w.threeDot} ref={ref}>
        <Icon i="ios-more-rotated" size={20} />
      </a>
      {show && (
        <PopoverLinkMenu target={ref} onRequestClose={() => setShow(false)}>
          {actions}
        </PopoverLinkMenu>
      )}
    </div>
  );
};
